var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalMarketing2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 63,
    width: 63,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.66 5.31V49.4h15.66L15.86 42l15.71-26.15L47.27 42l-5.46 7.4h15.67V5.31z",
    fill: "#FFF",
    fillRule: "nonzero",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.14 54.4H.66V.31h61.82V54.4H44",
    stroke: "#FFF",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 61.91v-8.7L47.27 42l-15.7-26.15L15.86 42l8.28 11.21v8.7m7.43-23.03V15.85",
    stroke: "#FFF",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.57,
    cy: 38.88,
    fill: "#FFF",
    fillRule: "nonzero",
    r: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalMarketing2);
export default __webpack_public_path__ + "static/media/DigitalMarketing2.0ebf991d3e1b6b5eac9729d14fe91b91.svg";
export { ForwardRef as ReactComponent };